import { BucketEntry } from '../../store/api';
import { mapValidItems } from '../mapping';
import { isNotBlank, isPresent, validateAll, validateAndLogOnErrors, validateField } from '../validation';
import { CategoryPageBucketEntry } from '../../../models/CategoryPage';

const validateKey = validateAll(isPresent, isNotBlank);
const validateValue = validateAll(isPresent, isNotBlank);

const categoryPageBucketValidation = validateAll<BucketEntry>(
    validateField('key', validateKey),
    validateField('value', validateValue)
);

const isBucketValid = (bucket: BucketEntry): boolean => {
    return validateAndLogOnErrors(categoryPageBucketValidation, bucket);
};

export const mapCategoryPageBuckets = (
    buckets?: ReadonlyArray<BucketEntry>
): ReadonlyArray<CategoryPageBucketEntry> => {
    if (!buckets) {
        return [];
    }

    return mapValidItems(buckets, isBucketValid, entry => ({
        ...entry,
        key: entry.key!,
        value: entry.value!,
        buckets: mapCategoryPageBuckets(entry.buckets)
    }));
};
